import { useCart } from "../context/CartContext";
import { silverData } from "../data/silverData";


export default function FavouritesPage(){
const { favourites, addToCart, toggleFav } = useCart();
const items = silverData.filter(i=> favourites.includes(i.id));


return (
<div className="max-w-5xl mx-auto p-4 pt-24">
<h1 className="text-2xl font-bold mb-4">Favourites</h1>
{items.length===0 ? <p>No favourites yet.</p> : (
<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
{items.map(i=> (
<div key={i.id} className="bg-white p-3 rounded shadow flex gap-4">
<img src={i.image} alt="" className="w-28 h-28 object-cover rounded" />
<div className="flex-1">
<h3 className="font-semibold">{i.name}</h3>
<p className="text-gray-500">₹{i.discountedPrice}</p>
<div className="mt-2 flex gap-2">
<button onClick={()=> addToCart(i)} className="px-3 py-1 border rounded">Add to Cart</button>
<button onClick={()=> toggleFav(i.id)} className="px-3 py-1 border rounded">Remove</button>
</div>
</div>
</div>
))}
</div>
)}
</div>
);
}